import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ImageViewer = _resolveComponent("ImageViewer");
    return (_openBlock(), _createElementBlock("div", {
        ref: "mol2dViewContainer",
        class: "mol2d-view-container",
        style: _normalizeStyle(_ctx.containerStyle)
    }, [
        _createVNode(_component_ImageViewer, {
            onOnValidImageDetect: _ctx.onValidImageDetect,
            source: _ctx.svgContent,
            showDownloadButtons: _ctx.showDownloadButtons,
            maxHeight: _ctx.maxHeight
        }, null, 8, ["onOnValidImageDetect", "source", "showDownloadButtons", "maxHeight"])
    ], 4));
}
